import React from 'react';
import { Link } from 'react-router';
import { prefixLink } from 'gatsby-helpers';
import Header from 'pages/components/_header.js';

import 'css/layout.scss';

module.exports = React.createClass({
  propTypes () {
    return {
      children: React.PropTypes.any,
    }
  },
  render () {
    const isHome = this.props.location.pathname === prefixLink('/');

    return (
      <div className={isHome ? 'home': ''}>
        <Header></Header>
        <main>
          <div className="container">
            {this.props.children}
          </div>
        </main>
      </div>
    )
  },
})



// WEBPACK FOOTER //
// ./_template.jsx